import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntry} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY, BRAND_KEY_FILTER_CS} from '../../brand'

let prefix = ''
if (BRAND_KEY === 'kenwood' || BRAND_KEY === 'braun') prefix = `${BRAND_KEY}_`

export const useGetCountrySelector = () => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()

    const getCountrySelector = async () => {
        const response = await getEntry({
            stack,
            contentTypeUid: `${prefix}country_selector`,
            locale: locale.alias,
            brand: BRAND_KEY_FILTER_CS,
        })
        return response ? response?.[0] ?? null : null
    }

    const query = useQuery(['country_selector'], () => getCountrySelector())

    return query
}
